import React, { FC } from 'react';
import styled, { AnyStyledComponent } from 'styled-components';


interface FixedAspectProps {
    ratio?: string;
    children?: any;
}

interface OuterWrapperProps {
    percentage: number;
}

const OuterWrapper: AnyStyledComponent =  styled.div`
    position: relative;
    width: 100%;
    height: auto;
    padding-top: ${({percentage}: OuterWrapperProps) => percentage }%;
    overflow: hidden;
`;

const InnerWrapper: AnyStyledComponent = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
`;

const FixAspect: FC<FixedAspectProps> = ({ ratio = '1:1', children }: FixedAspectProps) => {
  // Destructure resulting array into 'width' and 'height'
  const ratioArr: string[] = ratio.split(':');
  const width: number = parseFloat(ratioArr[0]);
  const height: number = parseFloat(ratioArr[1]);

  // Calculate percentage value using 'width' and 'height'
  const percentage: number = (height / width) * 100;

  return (
    <OuterWrapper
      percentage={ percentage }
    >
      <InnerWrapper>
        {children}
      </InnerWrapper>
    </OuterWrapper>
  );
};

export default FixAspect;
